import { infiniteListPageSize } from "../models/consts";
import { Base } from "./base";
var ListItems = /** @class */ (function () {
    function ListItems(obj) {
        this.hasMore = obj && obj.hasMore || false;
        this.page = obj && obj.page || 1;
        this.pageSize = obj && obj.pageSize || infiniteListPageSize;
        this.sortColumn = obj && obj.sortColumn || "";
        this.sortOrderIsAsc = obj && obj.sortOrderIsAsc || false;
        this.items = [];
    }
    ListItems.create = function (type) {
        var obj = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            obj[_i - 1] = arguments[_i];
        }
        var result = new ListItems(obj);
        result.items = Base.getTypedArray(obj ? obj.items : null, type);
        return result;
    };
    ;
    return ListItems;
}());
export { ListItems };
